import { MapPin } from "lucide-react";
import type { AdminZone } from "../types/api";

export function AdminZoneCard({ zone }: { zone: AdminZone | null }) {
  if (!zone) {
    return (
      <div className="rounded-xs border-[1.2px] border-mef-yellow bg-mef-yellow-tint p-4">
        <div className="flex items-center gap-2 text-[13px] font-medium text-black/80">
          <MapPin className="h-4 w-4" />
          <span>No administrative zone</span>
        </div>
        <p className="mt-1 text-[13px] leading-4 text-black/60">
          This point falls outside any country boundary (ocean or unmapped area).
        </p>
      </div>
    );
  }
  return (
    <div className="rounded-xs border-[1.2px] border-mef-separator bg-white p-4 shadow-mef-card">
      <div className="flex items-center gap-2 text-[13px] text-black/60">
        <MapPin className="h-4 w-4 text-mef-orange" />
        <span className="font-medium text-black/80">
          {zone.level_label} · {zone.country}
        </span>
      </div>
      <div className="mt-1 text-[16px] leading-5 font-medium text-black/80">
        {zone.name ?? "—"}
      </div>
      <div className="mt-0.5 text-[11px] uppercase tracking-[0.04em] text-black/40">
        {zone.gid}
      </div>
    </div>
  );
}
